import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Tools({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M11.8302 15L16.8302 20C17.6502 20.82 19.0002 20.82 19.8302 20C20.6502 19.17 20.6502 17.82 19.8302 17L14.8302 12M6.84018 7.00001L10.3402 10.5M20.9102 5.84001C20.9302 5.86001 20.9502 5.89001 20.9602 5.92001C21.4302 7.48001 21.0602 9.25001 19.8202 10.48C18.5602 11.73 16.7802 12.089 15.2002 11.59L6.85318 19.93C6.03318 20.74 4.71318 20.8 3.87318 20.02C2.98318 19.19 2.96318 17.81 3.81318 16.96L12.1932 8.57001C11.6932 6.99001 12.0532 5.20001 13.3032 3.95001C14.5332 2.71201 16.3032 2.34001 17.8632 2.81001C17.8932 2.82001 17.9232 2.83001 17.9432 2.86001L18.1032 3.02001C18.1732 3.09001 18.1732 3.22001 18.1032 3.30001L15.4602 5.93001L17.7802 8.25001L20.4102 5.61001C20.4802 5.53001 20.6102 5.53001 20.6902 5.61001L20.8502 5.77001L20.9102 5.84001ZM2.93018 4.29001L3.60018 6.31001C3.73018 6.71001 4.11018 6.99001 4.54018 6.99001H6.81918V4.71101C6.81918 4.28101 6.53918 3.89101 6.12918 3.76101L4.09918 3.08101C3.91918 3.02101 3.71918 3.06101 3.57918 3.20201L3.00918 3.76201C2.86918 3.89201 2.81918 4.09201 2.88818 4.27201L2.93018 4.29001Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default Tools;